$(function () {
    if (!$('#translation-quote-confirm-by-email-page').length) return false;

    $('.login-box').empty();

    let translation_id = getURLParameter("translation_id");
    let quote_id = getURLParameter("quotation");
    let key = getURLParameter("key");

    if (translation_id == null || key == null) {
        $('.login-box').append('<div class="alert alert-error">A technical error occurs : missing data</div>');
        return false;
    }
    $('.centered-spinner').css({ 'display': 'block' });

    $.ajax({
        type: "GET",
        url: `${getApiURL("translations")}/${translation_id}/quote/${quote_id}/key/${key}`,
        success: function (data) {
            $('.centered-spinner').hide();
            // Compatibility with older versions
            populateDetails(data);
            $('#translation-quotoe-confirm-form-block').show();
        },
        error: function(request, textStatus, errorThrown) {
            $('.login-box').append('<div class="alert alert-error">' +  parseCallbackError(request, errorThrown) + '</div>');
            $('.centered-spinner').hide();
        }
    });

    $("#submit").on("click", function(e) {
        e.preventDefault();
        confirmQuotation(translation_id, key);
    });
});

function confirmQuotation(translation_id, key) {
    $('.centered-spinner').css({ 'display': 'block' });
    $('#translation-quotoe-confirm-form-block').hide();
    $.ajax({
        type: "POST",
        url: getApiURL("translations") + '/quote/confirm',
        data: {
            translation_id: translation_id,
            key: key
        },
        dataType: 'json',
        success: function (data) {
            $('.centered-spinner').hide();
            $('.login-box').append('<div class="alert alert-success">' + data.detail + '</div>');
        },
        error: function (request, textStatus, errorThrown) {
            $('.login-box').append('<div class="alert alert-error">' +  parseCallbackError(request, errorThrown) + '</div>');
            $('.centered-spinner').hide();
        }
    });
}

function parseCallbackError(response, defaultError) {
    if (!response.responseJSON) return defaultError;

    if ('key' in response.responseJSON) return response.responseJSON.key;
    if ('login' in response.responseJSON) return response.responseJSON.login;
    if ('not_found' in response.responseJSON) return response.responseJSON.not_found;

    return defaultError;
}

function populateDetails(data) {
    let translation = data.translation;
    let quotation = data.quotation;
    $('[data-translationref]').html(atl_client_ref(translation.ID, translation.made_by));

    let text = `<tr><td style="width:60%;"><h6>Client</h6></td><td>${translation.client}</td></tr><tr><td><h6>Reference Number</h6></td><td>${translation.job_reference}</td></tr>`;
    $("#translation_table").append(text);

    if (quotation) {
        text = `<tr><td style="width:60%;"><h6>Total approximate cost</h6></td><td>$${quotation.client_fees} (incl. GST)</td></tr><tr><td><h6>Due date</h6></td><td>${moment(quotation.due_date).format("DD MMMM YYYY")}</td></tr>`;
        $("#quotation_table").append(text);
    } else {
        $("#quotation_title").hide();
    }
}